import { createStore } from "@xstate/store";
import { useSelector } from "@xstate/store-react";

const CLOCK_UPDATE_INTERVAL_MS = 60_000;

export const clockStore = createStore({
  context: { now: new Date() },
  on: {
    tick: () => ({ now: new Date() }),
  },
});

setInterval(() => clockStore.send({ type: "tick" }), CLOCK_UPDATE_INTERVAL_MS);

/** Reactive hook that returns the current time, updated every CLOCK_UPDATE_INTERVAL_MS */
export function useNow(): Date {
  return useSelector(clockStore, (s) => s.context.now);
}
